module.exports = __webpack_public_path__ + "assets/Dotted-Line.8a245c67.svg";